import styled from 'styled-components'

interface IStatusCardLegacyLeftStyledProps {}

export const StatusCardLegacyLeftStyled = styled.div<IStatusCardLegacyLeftStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  grid-area: left;
  padding: 0 0.5em;
`
